const totalFormatted = {
  width: 0,
  id: '$total_amount',
  accessor: row => row.total_amount,
  resizable: false,
  Cell: () => null
};

export default totalFormatted;
